<script setup lang="ts">
import { DtToast } from '@dialpad/dialtone/vue3/lib/toast';
import logger from '@/logger';
import { computed, onMounted } from 'vue';
import { PowerdialerNotoType } from '@/noto';
import type {
  PowerdialerAutoDismissToast,
  PowerdialerErrorToast,
  PowerdialerSemiManualToast,
  PowerdialerSyncErrorToast,
  PowerdialerSyncSuccessToast,
} from '@/noto';

const props = defineProps<{
  noto:
    | PowerdialerAutoDismissToast
    | PowerdialerSemiManualToast
    | PowerdialerErrorToast
    | PowerdialerSyncErrorToast
    | PowerdialerSyncSuccessToast;
}>();

const log = computed(() => logger.getChild(`NotoToast:${props.noto.id}`));
log.value.debug('Mounting');

onMounted(() => {
  log.value.debug('Mounted', props.noto.content);
});

const emit = defineEmits<{
  (event: 'close'): void;
  (event: 'action', name: string): void;
}>();

const hideCloseButton = computed(
  () => props.noto.type === PowerdialerNotoType.AutoDismiss,
);
</script>

<template>
  <!-- complicated inline logic to simplify unit tests injection of useI18n to script section -->
  <DtToast
    :title="
      typeof noto.content.title === 'object' && noto.content.title
        ? $t(noto.content.title?.key ?? '')
        : noto.content.title
    "
    :message="
      typeof noto.content.body === 'object' && noto.content.body
        ? $t(noto.content.body?.key ?? '')
        : noto.content.body
    "
    :show="true"
    :close-button-props="{
      ariaLabel: 'close',
    }"
    :hide-close="hideCloseButton"
    :kind="noto.meta.severity"
    class="d-w-auto"
    @close="emit('close')"
  />
</template>
